import { action, computed, makeObservable, observable } from "mobx";
import { createContext } from "react";
import { Estado } from "src/components/geral/RegioesDataTable/types";
import { AtributosDef } from "../commons/types";
import { Estabelecimento } from "../components/forms/inputs/InputSelectEstabelecimentos";
import { Regiao } from "../components/forms/inputs/InputSelectRegioes";
import { TiposContas, PopupsUsuarios } from "../components/forms/inputs/InputSelectTipoContas";
import api, { IDataRequest, IDataResponse, IHttpClient, STATUS_CODE, } from "../providers/api";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { CategoriaComponente, Componente, GrupoCategoriasComponentes, ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO } from "src/components/componentes/types";
import { FormasPagamentos } from "../components/forms/inputs/InputSelectFormasPagamentos";
import { CategoriaBiblioteca, PaginatedBiblioteca, PaginatedBibliotecaRow } from "src/components/bibliotecas/Listagem";

export interface GetBibliotecaParams {
  categoria_ids?: number[];
  page?: number;
  pageSize?: number;
  segmentos?: string[]
  search?: string
}

export interface Fabricante {
  id: number;
  nome: string;
  codigo: null;
  created_at: Date;
  updated_at: null;
}

const lists: string[] = [
  "userExtraInfo"
  // "tipos_contas",
  // "formas_pagamentos",
  // "componentes",
  // "fabricantes",
  // "atributos",
  // "estados",
  // "estabelecimentos",
  // "regioes",
  // "upload",
  // "categorias_componentes",
  // "parametros_funil",
  // "parametros_componentes",
  // "parametros_qitech",
  // "parametros_cupons_desconto",
  // "parametros_contas",
  // "parametros_precos",
  // "saldoFunil",
  // "parametros_projetos",
  // "parametros_projetos_verticais",
  // "parametros_gestao_pedidos",
];

export interface FiltroInversorMicroInversor {
  inversores: boolean;
  microinversores: boolean;
}

class DefaultListStore {
  _regioes: Regiao[];
  estados: Estado[] = [];
  _estabelecimentos: Estabelecimento[];
  categoriaComponente: CategoriaComponente[] = [];
  atributosDef: AtributosDef[] = [];
  componentes: Componente[] = [];
  fabricantes: Fabricante[] = [];
  tiposContas: TiposContas[] = [];
  popupsContas: PopupsUsuarios[] = [];
  saldoFunil: any = [];
  formasPagamentos: FormasPagamentos[] = [];
  categoriasBibliotecas: CategoriaBiblioteca[] = [];
  bibliotecas: PaginatedBiblioteca | null = null;
  provider: IHttpClient;

  permissoes:string[] = PermissionUtil.getPermissions();

  constructor(provider: IHttpClient) {
    this._regioes = [];
    this.tiposContas = [];
    this.popupsContas = [];
    this.formasPagamentos = [];
    this._estabelecimentos = [];
    this.provider = provider;

    makeObservable(this, {
      _regioes: observable,
      setRegioes: action,

      estados: observable,
      estadosList: computed,
      setEstados: action,

      _estabelecimentos: observable,

      bibliotecas: observable,
      categoriasBibliotecas: observable,

      atributosDef: observable,
      setAtributosDef: action,
      atributosDefComponentes: computed,

      categoriaComponente: observable,
      grupoCategoriasComponentes: computed,
      setCategoriaComponentes: action,

      componentes: observable,
      componentesModulos: computed,
      componentesInversores: computed,
      setComponentes: action,

      fabricantes: observable,
      setFabricantes: action,

      saldoFunil: observable,
      setSaldoFunil: action,

      tiposContas: observable,

      tiposContasRegrasPrecificacao: computed,
      tiposContasParceiros: computed,
      tiposContasClassificacoes: computed,
      tiposContasAutoClassificacoes: computed,
      tiposContasListagem: computed,
      tiposContasComissao: computed,

      setTiposContas: action,
      setPopupsUsuarios: action,

      formasPagamentos: observable,
      setFormasPagamentos: action,
    });
  }

  // Estabelecimentos
  get estabelecimentos(): Estabelecimento[] {
    return this._estabelecimentos;
  }

  setEstabelecimentos(regioes: Regiao[]): void {
    this._estabelecimentos = regioes;
  }
  
  
  addEstabelecimentos(regiao: Regiao): void {
    this.regioes.push(regiao);
  }
  
  setCategoriasBibliotecas(categoriasBibliotecas: CategoriaBiblioteca[]): void {
    this.categoriasBibliotecas = categoriasBibliotecas;
  }

  setBibliotecas(bibliotecas: PaginatedBiblioteca): void {
    this.bibliotecas = bibliotecas;
  }

  async getEstabelecimentos(): Promise<void> {
    try {
      const estabelecimentos = this.getLocal("estabelecimentos");
      if (estabelecimentos) {
        this.setEstabelecimentos(estabelecimentos);
      } else {
        let response = await this.provider.get({
          url: "/estabelecimentos",
        });

        if (response.statusCode === 200) {
          if (response.data.length > 0) {
            this.setLocal("estabelecimentos", response.data);
            this.setEstabelecimentos(response.data);
          }
        }
      }
    } catch (error) { }
  }

  async getCategoriasBibliotecas(): Promise<void> {
    try {
      const categoriasBibliotecas = this.getLocal("categorias_bibliotecas");
      if (categoriasBibliotecas) {
        this.setCategoriasBibliotecas(categoriasBibliotecas);
      } else {
        let response = await this.provider.get({
          url: "/cadastros/categorias_bibliotecas",
        });

        if (response.statusCode === 200) {
          if (response.data.length > 0) {
            this.setLocal("categorias_bibliotecas", response.data);
            this.setCategoriasBibliotecas(response.data);
          }
        }
      }
    } catch (error) { }
  }

  async getBibliotecas({ categoria_ids = [], page, pageSize, segmentos = [], search }: GetBibliotecaParams): Promise<void> {
    try {
      let url = '/cadastros/bibliotecas?ativo=true&orderby=created_at-desc'

      if(search){
        url += `&titulo_like_or_texto_like=${search}`
      }

      if (categoria_ids.length > 0) {
        url += `&categoria_biblioteca_id_in=${categoria_ids?.join(',')}`
      }

      if (String(page)) {
        url += `&page=${page}`
      }

      if (pageSize) {
        url += `&limit=${pageSize}`
      }

      if (segmentos.length > 0) {
        let localSegmentos = [...segmentos]
        const all = segmentos.find(item => item === 'todos')
        if (all) {
          localSegmentos = ['on', 'off', 'todos']
        }
        url += `&segmento_in=${localSegmentos.join(',')}`
      }

      let response = await this.provider.get({ url});

      if (response.statusCode >= 200 && response.statusCode < 300) {
        const result: PaginatedBiblioteca = {
          ...response.data,
          rows: response.data?.rows?.map((row: PaginatedBibliotecaRow) => {
            const comunicadores = ['leo', 'nina']
            const randomComunicador = comunicadores[Math.floor(Math.random() * comunicadores.length)];
            return {
              ...row,
              comunicador: randomComunicador
            }
          }) || []
        }
        this.setBibliotecas(result);
      }
    } catch (error) {
    }
  }

  async incrementClick(bibliotecaId: number): Promise<void> {
    try {
      await this.provider.put({
        url: `/cadastros/bibliotecas_estatisticas/${bibliotecaId}/cliques`,
      });
    } catch (error) {
    }
  }

  // Regioes
  get regioes(): Regiao[] {
    return this.getLocal("regioes");
  }

  setRegioes(regioes: Regiao[]): void {
    this._regioes = regioes;
  }

  addRegiao(regiao: Regiao): void {
    this.regioes.push(regiao);
  }

  async getRegioes(): Promise<void> {
    try {
      const regioes = this.getLocal("regioes");
      if (regioes) {
        this.setRegioes(regioes);
      } else {
        let response = await this.provider.get({
          url: "/regioes/cache",
        });

        if (response.statusCode === 200) {
          this.setLocal("regioes", response.data);
          this.setRegioes(response.data);
        }
      }
    } catch (error) { }
  }

  // Estados
  setEstados(estados: Estado[]): void {
    this.estados = estados;
  }

  get estadosList(): Estado[] {
    return this.estados;
  }

  async getEstados(): Promise<Estado[]> {
    const estados = this.getLocal("estados");
    if (estados) {
      this.setEstados(estados);
    } else {
      const requestConfig: IDataRequest = {
        url: "estados",
      };

      const response: IDataResponse = await this.provider.get(requestConfig);

      if (response.statusCode === STATUS_CODE.OK) {
        this.setLocal("estados", response.data.rows);
        this.setEstados(response.data.rows);
      }
    }

    return this.estados;
  }

  // Componentes Categorias
  setCategoriaComponentes(categoriaComponente: CategoriaComponente[]): void {
    this.categoriaComponente = categoriaComponente;
  }

  get grupoCategoriasComponentes(): GrupoCategoriasComponentes[] {
    const grupoCategoriasComponentes: GrupoCategoriasComponentes[] = [];

    const categoriasPai: CategoriaComponente[] =
      this.categoriaComponente.filter(
        (categoria: CategoriaComponente) =>
          categoria.categoria_componentes_id === null
      );

    for (let cotegoriaPai of categoriasPai) {
      const idsGrupos: number[] = this.categoriaComponente
        .filter(
          (categoria: CategoriaComponente) =>
            categoria.categoria_componentes_id === cotegoriaPai.id
        )
        .map((categoria: CategoriaComponente) => categoria.id);
      idsGrupos.push(cotegoriaPai.id);
      grupoCategoriasComponentes.push({
        id: cotegoriaPai.id,
        nome: cotegoriaPai.nome,
        grupoIds: idsGrupos,
      });
    }

    return grupoCategoriasComponentes;
  }

  async getCategoriaComponentes(): Promise<CategoriaComponente[]> {
    try {
      const categoriasComponentes = this.getLocal("categorias_componentes");
      if (categoriasComponentes) {
        this.setCategoriaComponentes(categoriasComponentes);
      } else {
        const requestConfig: IDataRequest = {
          url: "estoque/categorias_componentes",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("categorias_componentes", response.data);
          this.setCategoriaComponentes(response.data.rows);
          return response.data;
        }
        return [];
      }
      return this.categoriaComponente;
    } catch (error) {
      return [];
    }
  }

  setAtributosDef(atributosDef: AtributosDef[]): void {
    this.atributosDef = atributosDef;
  }

  async getParametrosDef(parametro: string): Promise<void> {
    try {
      if (parametro === "") {
        return;
      }
      const atributos = this.getLocal(`parametros_${parametro}`);
      if (atributos) {
        this.setAtributosDef(atributos);
      } else {
        const orderBy = "&orderby=entidade,entidade_codigo,ordem";
        const requestConfig: IDataRequest = {
          url: `atributos?entidade=parametros&entidade_codigo=${parametro}${orderBy}`,
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal(`parametros_${parametro}`, response.data);
          this.setAtributosDef(response.data);
        }
      }
    } catch (error) { }


  }

  async atributosParametros(parametro: string): Promise<AtributosDef[]> {
    try {
      const data = this.getLocal(`parametros_${parametro}`)
      if (data === null) {
        await Promise.all([
          this.getParametrosDef("funil"),
          this.getParametrosDef("componentes"),
          this.getParametrosDef("precos"),
          this.getParametrosDef("qitech"),
          this.getParametrosDef("cupons_desconto"),
          this.getParametrosDef("contas"),
          this.getParametrosDef("gestao_pedidos"),
          this.getParametrosDef("projetos"),
          this.getParametrosDef("projetos_verticais"),
          this.getParametrosDef("configuracao_componentes"),
        ]);

        return this.getLocal(`parametros_${parametro}`) || []
      }
      return data || [];
    } catch (error) {
      return []
    }
  }

  async getAtributosDef(): Promise<void> {
    try {
      const atributos = this.getLocal("atributos");
      if (atributos) {
        this.setAtributosDef(atributos);
      } else {
        const requestConfig: IDataRequest = {
          url: "atributos?orderby=entidade,entidade_codigo,ordem",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("atributos", response.data);
          this.setAtributosDef(response.data);
        }
      }
    } catch (error) { }
  }

  get atributosDefComponentes(): AtributosDef[] {
    const atributosComponentes: AtributosDef[] = this.getLocal("atributos")

    if (atributosComponentes) {
      return atributosComponentes.filter(
        (attr: AtributosDef) => attr.entidade === "componentes"
      );
    }

    return [];
  }

  async loadAtributosComponentes(): Promise<AtributosDef[]> {
    let atributos: AtributosDef[] = [];

    const requestConfig: IDataRequest = {
      url: "atributos?orderby=entidade,entidade_codigo,ordem",
    };

    const response: IDataResponse = await this.provider.get(requestConfig);

    if (response.statusCode === STATUS_CODE.OK) {
      atributos = response.data;

      return atributos;
    }

    return []
  }

  atributosDefByCategoria(categoria: number): AtributosDef[] {
    const atributosComponentes: AtributosDef[] = this.getLocal("atributos");

    if (atributosComponentes) {

      const attrs = atributosComponentes.filter((value: AtributosDef) =>
        value.entidade_codigo?.split(",")?.includes(categoria?.toString())
      ) || [];
      return attrs.sort((a, b) => {
        if (a.ordem < b.ordem) {
          return -1;
        }
        if (a.ordem > b.ordem) {
          return 1;
        }
        return 0;
      });
    }
    return [];
  }

  setFabricantes(fabricantes: Fabricante[]): void {
    this.fabricantes = fabricantes;
  }

  async getFabricantes(): Promise<void> {
    try {
      const fabricantes = this.getLocal("fabricantes");

      if (fabricantes) {
        this.setFabricantes(fabricantes);
      } else {
        const requestConfig: IDataRequest = {
          url: "fabricantes",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("fabricantes", response.data.rows);
          this.setFabricantes(response.data.rows);
        }
      }
    } catch (error) { }
  }

  setSaldoFunil(saldoFunil: any): void {
    this.saldoFunil = saldoFunil;
  }

  async getSaldoFunil(): Promise<void> {
    try {
      const saldo = this.getLocal("saldoFunil");

      if (saldo) {
        this.setSaldoFunil(saldo);
      } else {
        const requestConfig: IDataRequest = {
          url: "/componentes/cache/saldos_funil",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("saldoFunil", response.data);
          this.setSaldoFunil(response.data);
        }
      }
    } catch (error) {
      //TO DO: Verificar tratamento de erro
    }
  }


  // Componentes
  setComponentes(componentes: Componente[]): void {
    this.componentes = [...componentes];
  }

  async getComponentes(): Promise<Componente[]> {
    const componentes = this.getLocal("componentes");

    try {
      if (componentes) {
        this.setComponentes(componentes);
      } else {
        const requestConfig: IDataRequest = {
          url: "estoque/componentes/?orderby=modelo&includes=atributos",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("componentes", response.data);
          this.setComponentes(response.data);
        }
      }
    } catch (error) {
      return []
    }

    return this.componentes;
  }

  async componentesLocal(): Promise<Componente[]> {
    try {
      const data = this.getLocal(`componentes`)
      return data || [];
    } catch (error) {
      return []
    }
  }

  get componentesModulos(): Componente[] {
    const modulosIds = [ID_MODULO];
    return this.componentes.filter(
      (comp: Componente) =>
        modulosIds.indexOf(comp?.categoria_componentes_id || 0) > -1
    );
  }

  get componentesInversores(): Componente[] {
    const InversoresIds = [ID_INVERSOR];
    return this.componentes.filter(
      (comp: Componente) =>
        InversoresIds.indexOf(comp?.categoria_componentes_id || 0) > -1
    );
  }

  async componentesInversoresMicroInversores(filtro: FiltroInversorMicroInversor): Promise<Componente[]> {
    let componentes: Componente[] = [];

    const requestConfig: IDataRequest = {
      url: "componentes/cache?categoria_componentes_id_in=2,30",
    };

    const response: IDataResponse = await this.provider.get(requestConfig);

    if (response.statusCode === STATUS_CODE.OK) {


      if (filtro.inversores) {
        const _inversores = this.componentes.filter(
          (comp: Componente) => comp?.categoria_componentes_id === ID_INVERSOR
        )

        for (let id of _inversores) {
          if (!componentes.includes(id)) {
            componentes.push(id)
          }
        }

      }

      if (filtro.microinversores) {

        const _microInversores = this.componentes.filter(
          (comp: Componente) => comp?.categoria_componentes_id === ID_MICROINVERSOR
        )

        for (let id of _microInversores) {
          if (!componentes.includes(id)) {
            componentes.push(id)
          }
        }
      }
    }

    return componentes;
  }

  componentesByCategoria(categoria: number): Componente[] {
    return (
      this.componentes.filter(
        (value: Componente) => value.categoria_componentes_id === categoria
      ) || []
    );
  }

  // Formas Pagamentos
  setFormasPagamentos(formasPagamentos: FormasPagamentos[]): void {
    this.formasPagamentos = [...formasPagamentos];
  }

  async getFormasPagamentos(): Promise<FormasPagamentos[]> {
    const formasPagamentos = this.getLocal("formas_pagamentos");
    if (formasPagamentos) {
      this.setFormasPagamentos(formasPagamentos);
    } else {
      const requestConfig: IDataRequest = { url: "formas_pagamentos" };
      const response: IDataResponse = await this.provider.get(requestConfig);

      if (response.statusCode === STATUS_CODE.OK) {
        this.setLocal("formas_pagamentos", response.data.rows);
        this.setFormasPagamentos(response.data.rows);
      }
    }

    return this.formasPagamentos;
  }

  // Tipos de Contas
  setTiposContas(tiposContas: TiposContas[]): void {
    this.tiposContas = [...tiposContas];
  }

  async getTiposContas(): Promise<TiposContas[]> {
    const tiposContas = this.getLocal("tipos_contas");
    if (tiposContas) {
      this.setTiposContas(tiposContas);
    } else {
      const requestConfig: IDataRequest = { url: "tipos_contas" };
      const response: IDataResponse = await this.provider.get(requestConfig);

      if (response.statusCode === STATUS_CODE.OK) {
        this.setLocal("tipos_contas", response.data.rows);
        this.setTiposContas(response.data.rows);
      }
    }

    return this.tiposContas;
  }

  // Popups registrados para Contas
  setPopupsUsuarios(popupsContas: PopupsUsuarios[]): void {
    this.popupsContas = [...popupsContas];
    this.setLocal("popups_usuarios", this.popupsContas);
  }

  async getPopupsUsuarios(userId: number): Promise<PopupsUsuarios[]> {
    const popupsContas = this.getLocal("popups_usuarios");
    if (popupsContas) {
      this.popupsContas = popupsContas;
    } else {
      if (!PermissionUtil.can(PermissionUtil.PERMISSION_POPUPS_LISTAGEM, this.permissoes)) {
        return [];
      }
      const requestConfig: IDataRequest = { url: "cadastros/popups_usuarios/user/" + userId };
      const response: IDataResponse = await this.provider.get(requestConfig);
      if (response.statusCode === STATUS_CODE.OK) {
        this.setPopupsUsuarios(response.data);
      }
    }
    return this.popupsContas;
  }

  get tiposContasRegrasPrecificacao(): TiposContas[] {
    return this.tiposContas.filter(
      (tipoConta: TiposContas) => tipoConta.regras_precificacao
    );
  }

  get tiposContasParceiros(): TiposContas[] {
    return this.tiposContas.filter(
      (tipoConta: TiposContas) => tipoConta.parceiro
    );
  }

  get tiposContasClassificacoes(): TiposContas[] {
    return this.tiposContas.filter((tipoConta: TiposContas) => tipoConta?.classificacao);
  }

  get tiposContasAutoClassificacoes(): TiposContas[] {
    return this.tiposContas.filter((tipoConta: TiposContas) => tipoConta?.classificacao && tipoConta?.parceiro);
  }

  get tiposContasListagem(): TiposContas[] {
    return this.tiposContas.filter((tipoConta: TiposContas) => tipoConta?.listagem);
  }

  get tiposContasComissao(): TiposContas[] {
    return this.tiposContas.filter((tipoConta: TiposContas) => tipoConta?.comissao);
  }

  removeCache(key?: string): void {
    if (key) {
      if (lists.includes(key)) {
        this.deleteLocal(key);
      }
    } else {
      for (let cache of lists) {
        this.deleteLocal(cache);
      }
    }
  }

  async refreshCache(): Promise<void> {
    this.removeCache();
    this.getAtributosDef();
    this.getRegioes();
    this.getEstados();
    this.getCategoriaComponentes();
    this.getComponentes();
    this.getFabricantes();
    this.getEstabelecimentos();
    this.getTiposContas();
    this.getUpload();
    this.getFormasPagamentos();
  }

  async getUpload(): Promise<void> {
    try {
      const upload = this.getLocal("upload");
      if (!upload) {
        const requestConfig: IDataRequest = {
          url: "uploads",
        };

        const response: IDataResponse = await this.provider.get(requestConfig);

        if (response.statusCode === STATUS_CODE.OK) {
          this.setLocal("upload", response.data);
        }
      }
    } catch (error) { }
  }

  get uploadUrl(): string {
    const upload = this.getLocal("upload");

    if (!upload) return ""

    let url: string = `${upload?.url}`;

    if (!!upload?.["port"] && `${upload?.["port"]}` !== "80") {
      url = `${url}:${upload["port"]}`;
    }

    return url;
  }

  // Sitemas

  async getSistemas() {
    const requestConfig: IDataRequest = {
      url: "/sistemas",
    };
    const response: IDataResponse = await this.provider.get(requestConfig);
    if (response.statusCode === STATUS_CODE.OK) {
      return response.data;
    } else {
      return []
    }
  }

  // Genericas
  setLocal(key: string, value: any): void {
    localStorage.setItem(`solar.${key}`, JSON.stringify(value));
  }

  getLocal(key: string): any {
    const value = localStorage.getItem(`solar.${key}`);
    if (value === null) {
      return null;
    }
    return JSON.parse(value);
  }

  deleteLocal(key: string): void {
    localStorage.removeItem(`solar.${key}`);
  }
}

const defaultListStore = new DefaultListStore(api);

export default defaultListStore;

const defaultListStoreContext = createContext(defaultListStore);

export { defaultListStoreContext };
